export function reorderItem<T>(list: T[], src: number, dst: number) {
  if (src === dst) {
    return list;
  }

  if (src > dst) {
    const res = [...list.slice(0, dst), list[src], ...list.slice(dst, src), ...list.slice(src + 1)];
    return res;
  } else {
    const res = [...list.slice(0, src), ...list.slice(src + 1, dst + 1), list[src], ...list.slice(dst + 1)];
    return res;
  }
}

export function moveItem<T>(source: T[], destination: T[], sourceIndex: number, destinationIndex: number) {
  const sourceNew = [...source.slice(0, sourceIndex), ...source.slice(sourceIndex + 1)];
  const destinationNew = [
    ...destination.slice(0, destinationIndex),
    source[sourceIndex],
    ...destination.slice(destinationIndex),
  ];
  return [sourceNew, destinationNew];
}
